// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3ZxLl","actions":"GroupTable_actions__HDwTU","deleteModalFooter":"GroupTable_deleteModalFooter__1rkXd"};